import { FaWhatsapp, FaInstagram, FaYoutube } from "react-icons/fa";
import { useState } from "react";

function SocialIcons() {
  const [hovered, setHovered] = useState(null);

  return (
    <div style={styles.container}>
      
      {/* WhatsApp */}
      <a 
        href="https://wa.me/918953395689" 
        target="_blank" 
        rel="noreferrer"
        style={{
          ...styles.icon,
          background: "#25D366",
          transform: hovered === "wa" ? "scale(1.2)" : "scale(1)"
        }}
        onMouseEnter={() => setHovered("wa")}
        onMouseLeave={() => setHovered(null)}
      >
        <FaWhatsapp />
      </a>

      {/* Instagram */}
      <a 
        href="https://instagram.com/yourusername" 
        target="_blank" 
        rel="noreferrer"
        style={{
          ...styles.icon,
          background: "#E1306C",
          transform: hovered === "ig" ? "scale(1.2)" : "scale(1)"
        }}
        onMouseEnter={() => setHovered("ig")}
        onMouseLeave={() => setHovered(null)}
      >
        <FaInstagram />
      </a>

      {/* YouTube */}
      <a 
        href="https://youtube.com/@yourchannel" 
        target="_blank" 
        rel="noreferrer"
        style={{
          ...styles.icon,
          background: "#FF0000",
          transform: hovered === "yt" ? "scale(1.2)" : "scale(1)"
        }}
        onMouseEnter={() => setHovered("yt")}
        onMouseLeave={() => setHovered(null)}
      >
        <FaYoutube />
      </a>

    </div>
  );
}

const styles = {
  container: {
    position: "fixed",
    top: "50%",
    right: "20px",
    transform: "translateY(-50%)",
    display: "flex",
    flexDirection: "column",
    gap: "15px",
    zIndex: 1000
  },
  icon: {
    width: "50px",
    height: "50px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "white",
    fontSize: "22px",
    borderRadius: "50%",
    textDecoration: "none",
    transition: "0.3s ease"
  }
};

export default SocialIcons;